var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content",class:_vm.sidebarState},[_c('manager-header'),_c('router-view'),_c('div',{staticClass:"footer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }